import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { DevicesStore, FeatureService, InstallationFeaturesStore } from '@store';
import {
  ConsolidatedFeature,
  Feature,
  FeatureNames,
  FeaturePropertyKey,
  IsNumberValueProperty,
} from '@vi-iot/client/index';
import { Observable, take } from 'rxjs';

@Component({
  selector: 'app-photovoltaic-overall',
  templateUrl: './photovoltaic-overall.component.html',
  styleUrls: ['./photovoltaic-overall.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PhotovoltaicOverallComponent implements OnInit {
  readonly featurePropertyKey = FeaturePropertyKey;
  productionCurrentConsolidated$: Observable<Feature<ConsolidatedFeature, unknown>>;
  productionCurrent$: Observable<Feature<IsNumberValueProperty, never>>;

  private deviceId: string;

  constructor(
    public devicesStore: DevicesStore,
    private installationFeaturesStore: InstallationFeaturesStore,
    private featureService: FeatureService
  ) {}

  ngOnInit(): void {
    this.devicesStore.getSelectedDevice$.pipe(take(1)).subscribe((richDevice) => {
      this.deviceId = richDevice.id;
      this.setProductionFeature();
    });
  }

  private setProductionFeature(): void {
    this.productionCurrentConsolidated$ = this.featureService.getConsolidatedFeatures(
      FeatureNames.productionCurrentConsolidated
    );
    this.productionCurrent$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.productionCurrent,
      this.deviceId
    );
  }
}
